import React, { createElement, FC } from "react";
import { MenuItem } from "@constants/menu";
import { useTranslation } from "react-i18next";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Link } from "react-router-dom";

const Item: FC<
  MenuItem & { disableGutters?: boolean } & {
    compact: boolean;
    selected: boolean;
    onNavigate?: () => void;
  }
> = ({
  icon,
  id,
  title,
  path,
  disableGutters = true,
  compact,
  selected,
  onNavigate,
}) => {
  const { t } = useTranslation();

  return (
    <ListItem disableGutters={disableGutters}>
      <ListItemButton
        id={id}
        component={Link}
        to={path}
        selected={selected}
        onClick={onNavigate}
        sx={{
          borderRadius: "4px",
          "&.Mui-selected, &.Mui-selected:hover": {
            backgroundColor: "primary.main",
            color: "primary.contrastText",
          },
          "&.Mui-selected.Mui-focusVisible": {
            backgroundColor: "primary.dark",
          },
          svg: {
            color: selected ? "primary.contrastText" : "grey.800",
          },
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: compact ? "24px" : "40px",
          }}
          aria-label={t(title)}
        >
          {createElement(icon, { fontSize: "medium" })}
        </ListItemIcon>
        {!compact && (
          <ListItemText
            primary={t(title)}
            primaryTypographyProps={{ noWrap: true }}
          />
        )}
      </ListItemButton>
    </ListItem>
  );
};

export default Item;
